/**
 * Filter by blacklisted keys
 * @param {object} obj
 * @param {object} blacklist
 */
export const filterByKeys = (obj, blacklist) => Object.keys(obj)
    .filter(key => !blacklist.includes(key))
    .reduce((newObj, key) => {
        newObj[key] = obj[key];
        return newObj;
    }, {});

/**
 * Check if is json type from string
 * @param {string} data
 */
export const isJSON = (data) => {
    var ret = true;
    try {
        JSON.parse(data);
    } catch (e) {
        ret = false;
    }
    return ret;
}
